<script setup>
import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
import { usePermissionStore } from '@stores/permission';

// Store
const permissionStore = usePermissionStore();
const applicationStore = useApplicationStore();

// Composants
const Loader = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/UI/Loader'));
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const EditForm = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Permissions/Sections/List/Item/EditForm'));
const GroupList = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Permissions/Sections/Groups/List'));

const router = useRouter();
const route = useRoute();
const { t } = useI18n();

const sectionId = parseInt(route.params.sectionId);
const section = computed(() => permissionStore.getSectionById(sectionId));

// ready est vrai une fois la section chargée.
// Cela permet d'afficher un loader le temps du chargement des données
const ready = ref(false);

// Vrai s'il y a eu une erreur pendant le chargement de la section
const loadingSectionError = ref(false);

// Application courante
const currentApplication = computed(() => applicationStore.getCurrent);

// Initialisation de la page : vérification des permissions et titre de la page
const initPage = (() => {
    if(! section.value.can_edit) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        document.title = t('page.admin.permissions.sections.edit.title', {
            name: section.value.display_name
        }) + ' - ' + currentApplication.value.name;
    }
});

onMounted(() => {
    permissionStore.loadSectionById(sectionId).then(() => {
       initPage();
    }).catch((e) => {
        loadingSectionError.value = true;
    }).finally(() => {
        ready.value = true;
    });
});
</script>

<template>
    <layout wrapperContentClasses="wrapper_edit-add">
        <loader v-if="! ready"></loader>
        <template v-else>
            <p v-if="loadingSectionError || ! section" class="generic-message generic-message-error">{{ $t('page.admin.permissions.sections.edit.loadingError') }}</p>
            <template v-else>
                <div class="content_header">
                    <div class="content-header_title">
                        <h1 class="first-title">{{ $t('page.admin.permissions.sections.edit.title', { name: section.display_name }) }}</h1>
                        <p>{{ $t('page.admin.permissions.sections.edit.description', { name: section.display_name }) }}</p>
                    </div>
                </div>
                <div class="wrapper_content ">
                    <edit-form :section="section"></edit-form>
                    <group-list :section="section"></group-list>
                </div>
            </template>
        </template>
    </layout>
</template>
